import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import MediaCard from '@/components/base/MediaCard';
import { works } from '@/mocks/films';

const tabs = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '电影' },
  { key: 'tv', label: '电视剧' },
] as const;

export default function LatestNews() {
  const [tab, setTab] = useState<'all' | 'movie' | 'tv'>('all');

  const latest = useMemo(() => {
    const sorted = [...works].sort(
      (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    );
    const list = tab === 'all' ? sorted : sorted.filter((w) => w.type === tab);
    return list.slice(0, 8);
  }, [tab]);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新影视资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500">近期更新与热门作品，点击查看剧情介绍</p>
          </div>
          <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  tab === t.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {latest.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
            <i className="ri-inbox-line text-3xl text-foreground-400" />
            <p className="mt-3 text-sm text-foreground-500">暂无更新，敬请期待新的影视资讯</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {latest.map((work) => (
              <MediaCard key={work.id} work={work} />
            ))}
          </div>
        )}

        <div className="mt-8 flex justify-center">
          <Link
            to={tab === 'tv' ? '/category/tv' : '/category/movie'}
            className="inline-flex items-center gap-2 rounded-md border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50 whitespace-nowrap"
          >
            查看更多作品
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}